import { useEffect, useState } from 'react'
export const useTelegram = () => {

    const [FirstName, setFirstName] = useState(false)
    const [LastName, setLastName] = useState(null)
    const [photoUrl, setPhotoUrl] = useState(null)
    const [ChatId, setChatId] = useState(null)
    const [params, setParams] = useState(null);

    const app = window?.Telegram?.WebApp;

    if (app) {
        app.ready();
        app.expand();
    }

    useEffect(() => {

        if (window.Telegram && window.Telegram.WebApp) {
            if (app.initDataUnsafe.user) {
                app.enableClosingConfirmation();
                // app.setHeaderColor("#5693f5");
                app.setHeaderColor(app.themeParams.bg_color);

                app.expand();
                if (app.isVersionAtLeast('7.10')) {
                    app.setBottomBarColor(app.themeParams.bottom_bar_bg_color || app.themeParams.bg_color);
                    if (app.requestFullscreen) {
                        app.requestFullscreen();
                    } else {
                        app.expand();
                    }
                }



                document.documentElement.setAttribute('lang', 'fa');
                app.isVerticalSwipesEnabled = false;
                setChatId(app.initDataUnsafe.user.id);
                setFirstName(app.initDataUnsafe.user.first_name);
                setLastName(app.initDataUnsafe.user.last_name);
                setPhotoUrl(app.initDataUnsafe.user.photo_url);
            }
        }

        // setChatId(77672927);//جلال
        // setChatId(7282050286);//جلال
        // setChatId(6382898050);//ادریس
        // setChatId(569862192);//ادریس
        // setChatId(6925871183);//یحیی
        // setChatId(947137244);//یحیی
        // setChatId(940000004);//اشتباه

        // setParams('sId_2_pId_4'.split('_'));
        //https://rabet24.shop/app?sId=2&pId=4
        // setParams('s_2'.split('_'));
    }, [])

    useEffect(() => {
        if (ChatId) {
            const queryParams = new URLSearchParams(window.location.search);
            const paramsObj = {};

            queryParams.forEach((value, key) => {
                paramsObj[key] = value;
            });
            if (paramsObj) {
                if (paramsObj.tgWebAppStartParam) {
                    setParams(paramsObj.tgWebAppStartParam.split('_'));
                } else
                    setParams("none");
            }

        }

    }, ChatId)

    return { ChatId, FirstName, LastName, photoUrl, params }
}